import FooterSection from "assets/Footer";
import Navbar from "../assets/Navbar";
import Banner from "../components/dashboardComponents/Banner";
import Catelouge from "../components/dashboardComponents/catelouge";
import FlashSale from "components/dashboardComponents/flashSale";
import WhyUs from "components/dashboardComponents/whyUs";
import TopCategories from "components/dashboardComponents/topCategories";
import NewProducts from "components/dashboardComponents/newProducts";
import TrendingProducts from "components/dashboardComponents/trendingProducts";
import SubCatalougeGroupByCatalouge from "components/dashboardComponents/SubCatalougeGroupByCatalouge";
import { useEffect, useState } from "react";
import YoutubePreview from "components/dashboardComponents/youtubePreview";
import FreeDeliveryProducts from "components/dashboardComponents/freeDeliveryProducts";
import RevealOnScroll from "components/RevealOnScroll";
import OffersSection from "components/dashboardComponents/OffersSection";
import CategorySection from "components/dashboardComponents/CategorySection2";
import ScrollToTopButton from "components/ScrollToTopButton";
import FindStoreSection from "components/dashboardComponents/FindStoreSection";
import PromotionalPopup from "components/PromotionalPopup";
import { FaGift } from "react-icons/fa";

const Dashboard = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [promoOpen, setPromoOpen] = useState(false);
  useEffect(() => {
    const hasSeenPromo = sessionStorage.getItem("hasSeenPromo");
    if (!hasSeenPromo) {
      setPromoOpen(true); // show popup
      sessionStorage.setItem("hasSeenPromo", "true"); // mark as seen for this session
    }
  }, []);
  const handlePromoView = () => {
    setPromoOpen(false);
    window.location.hash = "/hotOffers";
  };

  return (
    <div className="bg-gray-100 min-h-screen ">
      <Navbar />
      <PromotionalPopup
        icon={<FaGift />}
        open={promoOpen}
        badge="Hot Offer"
        subtitle="Limited-time discounts"
        title={"Hot Offers are Live"}
        message={"Exclusive discounted products for a limited time."}
        backgroundImageUrl={
          "https://images.unsplash.com/photo-1607082349566-1870b5cc6b79?auto=format&fit=crop&w=1600&q=80"
        }
        actionLabel="Explore"
        onAction={handlePromoView}
        onClose={() => setPromoOpen(false)}
      />
      <main className="mx-auto w-full max-w-7xl pb-6">
        {/* <main className="mx-auto w-full max-w-7xl py-6 px-4 sm:px-6"> */}
        <RevealOnScroll delayMs={0}>
          <Banner />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <Catelouge />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <CategorySection />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <FlashSale />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <OffersSection />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <FreeDeliveryProducts />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <TrendingProducts />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <NewProducts />
        </RevealOnScroll>
        <SubCatalougeGroupByCatalouge />
        <RevealOnScroll delayMs={40}>
          <TopCategories />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <WhyUs />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <YoutubePreview />
        </RevealOnScroll>
        <RevealOnScroll delayMs={40}>
          <FindStoreSection />
        </RevealOnScroll>
        {/* <RevealOnScroll delayMs={40}>
          <WhyChooseUsSection2 />
        </RevealOnScroll> */}
      </main>
      <FooterSection />
      {showScrollTop && <ScrollToTopButton />}
    </div>
  );
};

export default Dashboard;
